import React from 'react';
import { Button } from 'react-bootstrap';
import { FaFileAlt, FaSlidersH, FaSave, FaPrint } from 'react-icons/fa';
import DefaultButton from '../ReusableComponents/DefaultButton';

export default function DiagramacaoEditorHeader({ title, description, collapsed, onToggle, onSave, onPrint, backTo, disabled }) {
    return <div className="card diagramacao-page-header hidethis"><div className="card-body">
        <div className="diagramacao-page-heading"><span className="diagramacao-page-icon"><FaFileAlt /></span><div><h4>{title}</h4><p>{description}</p></div></div>
        <div className="diagramacao-page-actions"><DefaultButton bg="back" text="Voltar" to={backTo} search="?tab=2" />
            <Button variant="outline-secondary" onClick={onToggle} aria-expanded={!collapsed}><FaSlidersH /> {collapsed ? 'Mostrar configurações' : 'Ocultar configurações'}</Button>
            <Button variant="info" disabled={disabled} onClick={onPrint}><FaPrint /> Salvar e imprimir</Button>
            <Button variant="success" disabled={disabled} onClick={onSave}><FaSave /> Salvar diagramação</Button>
        </div>
    </div></div>;
}
